<div class="container-fluid">
  <div class="row">
    <div class="col-lg-12">
      <h2>@if (bedrooms) {
        <span>{{bedrooms.length}}</span>
      } Bedroom(s)</h2>
      @if (bedrooms?.length > 0) {
        <h3 class="fw-normal text-dark">Sleeps {{totalSleepingCapacity}}</h3>
      }
    </div>
    <div class="col-lg-12">
      <button mat-button style="padding:0; color:green" (click)="openFormAdd()">
        <mat-icon style="font-size:140%">add_circle</mat-icon> Add Bedroom
      </button>
    </div>
  </div>
  <div class="row">
    @for (bedroom of bedrooms; track bedroom; let i = $index) {
      <div class="col-lg-12">
        <h2>Bedroom {{i+1}}</h2>
        <app-bedroom-form [shortTermRentalId]="shortTermRentalId" [featuresList]="featuresList" [bedroom]="bedroom" (doAdd)="addBedroom($event)" (doUpdate)="updateBedroom($event)"
        (doDelete)="deleteBedroom($event)"></app-bedroom-form>
        <br><br>
        <mat-divider></mat-divider>
        <br><br>
      </div>
    }
  </div>
</div>
